import { client } from "./supabase";

// ─── Sticky en el panel Futuros de FlujoCajaV2 ─────────────────────────────────
//
// Fijar filas de "Futuros" arriba de todo, con el saldo acumulado descontándolas primero
// (docs/modulos/flujo-caja-v2.md § Sticky en Futuros). Capa de presentación (10.244): la
// tabla `flujo_caja_sticky` solo guarda QUÉ entry_id está fijado y en qué orden — la fila
// sigue siendo la misma entry de siempre (fecha, color, kebab, vinculación).
//
// Quién ve / quién actúa (10.279): TODOS los autenticados ven las sticky (RLS SELECT abierto);
// fijar/soltar (INSERT/DELETE) es SOLO Ignacio, por ID ESTABLE de usuario (10.219 — nunca por
// rol/nombre) — mismos ids que EQUIPO_INTERNO (src/constants/equipoInterno.js).
export const IDS_STICKY_AUTORIZADOS = [1, 4];

export const puedeGestionarSticky = (userId) => IDS_STICKY_AUTORIZADOS.includes(userId);

// Lee las sticky de un país, en orden de fijado (columna `orden` ascendente).
export const getStickyFuturos = async (pais) => {
  const { data, error } = await client
    .from("flujo_caja_sticky")
    .select("*")
    .eq("pais", pais)
    .order("orden", { ascending: true });
  if (error) throw error;
  return data || [];
};

// Fija una entry. `ordenMax` es el `orden` más alto YA fijado en ese país (0 si no hay
// ninguna) — el caller lo calcula desde el state local (10.234, sin query extra por fijado).
export const fijarEntrySticky = async (pais, entryId, ordenMax, userId) => {
  const { data, error } = await client
    .from("flujo_caja_sticky")
    .insert({ pais, entry_id: String(entryId), orden: ordenMax + 1, creado_por: userId })
    .select()
    .single();
  if (error) throw error;
  return data;
};

// Suelta una entry fijada.
export const soltarEntrySticky = async (pais, entryId) => {
  const { error } = await client.from("flujo_caja_sticky").delete().eq("pais", pais).eq("entry_id", String(entryId));
  if (error) throw error;
};

// "Soltar todas" del header (Fase 2) — vacía sin confirmación, solo del país activo.
export const soltarTodasSticky = async (pais) => {
  const { error } = await client.from("flujo_caja_sticky").delete().eq("pais", pais);
  if (error) throw error;
};
